import { Badge } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { BodyText } from "@/components/ui/Text";
import type { CodifiedAllergen } from "./useAmazonVisitIntake";

export const CiqAllergySingleRow = ({
  allergen,
  onAdd,
  isPending,
  isAdded,
  addedLabel = "Added",
}: {
  allergen: CodifiedAllergen;
  onAdd: (allergen: CodifiedAllergen) => void;
  isPending: boolean;
  isAdded: boolean;
  addedLabel?: string;
}) => (
  <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 py-1 rounded">
    <BodyText size="sm">{allergen.name ?? ""}</BodyText>
    {isAdded ? (
      <div className="flex items-center shrink-0" style={{ height: 25 }}>
        <Badge variant="ai">
          <BodyText size="xs">{addedLabel}</BodyText>
        </Badge>
      </div>
    ) : (
      <Button
        size="xs"
        type="button"
        onClick={() => onAdd(allergen)}
        isLoading={isPending}
        className="shrink-0 transition-none bg-button-superclinical text-button-primary border border-ai"
      >
        Add
      </Button>
    )}
  </div>
);
